var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input-select',{attrs:{"id":"lgbtq","value":_vm.value,"name":"lgbtq","label":"LGBTQ+ Status","placeholder":"Prefer not to say","placeholder-enabled":"","options":[
    { id: 'true', display_label: 'LGBTQ+' },
    { id: 'false', display_label: 'Not LGBTQ+' }
  ]},on:{"input":function (val) { return _vm.$emit('input', val); }}})}
var staticRenderFns = []

export { render, staticRenderFns }